import React from "react";
import PropTypes from 'prop-types';

class PaymentModal extends React.Component {

    render() {
        return (
            <iframe title="paymentSrc" style={{width: '100%', height: '100%'}} src={this.props.paymentPath}> </iframe>
        );
    }
}

PaymentModal.propTypes = {
    paymentPath: PropTypes.string.isRequired
  };

export default PaymentModal;